import { useRef } from "react";
import {
  UploadSimpleIcon as Upload,
  TrashIcon as Trash,
  MagnifyingGlassIcon as Search,
} from "@phosphor-icons/react";

export default function EntityToolbar({
  entity,
  total,
  query,
  setQuery,
  setPageNum,
  onImport,
  onTruncate,
  hasRows,
}) {
  const fileInputRef = useRef(null);
  return (
    <div className="ml-card p-4 flex flex-wrap items-center gap-3">
      <div className="flex-1 min-w-[160px]">
        <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">
          {entity?.source}
        </div>
        <div className="font-medium text-lg">{entity?.label}</div>
        <div className="text-xs text-[var(--ml-text-secondary)]">
          {total != null
            ? `${total} row${total === 1 ? "" : "s"}`
            : "—"}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="relative">
          <Search
            size={14}
            className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[var(--ml-text-secondary)]"
          />
          <input
            type="search"
            placeholder="Search…"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setPageNum(0);
            }}
            className="ml-input pl-8 w-48"
            data-testid="metadata-search"
          />
        </div>
        {entity?.importable && (
          <>
            <input
              ref={fileInputRef}
              type="file"
              accept=".csv,text/csv"
              onChange={(e) => onImport(e, fileInputRef)}
              className="hidden"
              data-testid="metadata-csv-input"
            />
            <button
              onClick={() => fileInputRef.current?.click()}
              className="ml-btn-primary flex items-center gap-1.5"
              data-testid="metadata-import-btn"
            >
              <Upload size={14} weight="bold" /> Import CSV
            </button>
          </>
        )}
        <button
          onClick={onTruncate}
          disabled={!hasRows}
          className="ml-btn-ghost text-[var(--ml-error)] disabled:opacity-40 flex items-center gap-1.5"
          data-testid="metadata-truncate-btn"
        >
          <Trash size={14} /> Clear
        </button>
      </div>
    </div>
  );
}
